import React from "react";
import RedStrikeThrough from "../components/Home/RedStrikeThrough";

import Developer from "../svgs/Developer.svg";
import Productive from "../svgs/Productive.svg";
import Interview from "../svgs/Interview.svg";
import Season from "../svgs/Season.svg";
import Lessons from "../svgs/Lessons.svg";
import Features from "../svgs/Features.svg";
import Time from "../svgs/Time.svg";
import Certificate from "../images/Certificate.png";
import michael from "../images/Michael.jpeg";
import paul from "../images/Paul.jpeg";
import kate from "../images/Kate.jpeg";

export const infoGraphics = [
    {
        title: "An essential skill for the Cloud",
        text: `
            In the time of Cloud, Docker, and 
            Kubernetes, you are required to 
            use the Linux command line daily 
        `,
        graphic: <Developer height="160" width="253" />,
    },
    {
        title: "Grow your flexibility",
        text: `
            Tap into hidden functions of your system
            with shortcuts, time-saving commands, and tools
        `,
        graphic: <Productive height="160" width="186" />,
    },
    {
        title: "Land high-paying opportunities",
        text: `
           Gain skills that are a sign of a good developer
           in any employer’s mind
        `,
        graphic: <Interview height="160" width="211" />,
    },
    {
        title: "Save time, work on more projects",
        text: `
            Optimize your process and workflow.
            Get more done with less hardware resources
        `,
        graphic: <Season height="160" width="264" />,
    },
];

export const stories = [
    {
        title: (
            <span>
                Amazing learning experience
            </span>
        ),
        bullets: [
            <span>
                Use an actual interactive terminal right in your browser—<b>no setup needed</b>
            </span>,
            <span>
                <b>Lessons are fully interactive</b>, with built-in challenges
            </span>,
            <span>
                Get <b>instant feedback</b> and guidance as you type each command
            </span>,
            <span>
                <b>Solve real-world problems</b> step-by-step in a <b>guided environment</b>
            </span>,
        ],
        graphic: <Features />,
    },
    {
        title: "The Only Command-Line Course You Need",
        bullets: [
            <span>
                <b>10 comprehensive modules</b> covering everything from the basics to more advanced topics
            </span>,
            <span>
                Each module includes <b>cheatsheets and articles</b> for quick reference
            </span>,
            <span>
                Suitable for <b>beginners and seasoned users</b>—no prior knowledge required
            </span>,
            <span>
                Build terminal skills for <b>everyday development and troubleshooting</b> with a clear, structured learning path
            </span>,
        ],
        graphic: <Lessons />,
    },
    {
        title: "Certificate of completion",
        bullets: [
            <span>
                This isn’t a video course — it’s a real <b>learning experience</b>. You’ll move faster and remember more by doing, not just watching
            </span>,
            <span>
                Earn a <b>certificate that showcases your command-line expertise</b> — a great way to stand out professionally. A personalized certificate with your name is automatically generated once you complete all the lessons.
            </span>
           ],
        graphic: <img 
            src={Certificate} 
            alt="Certificate of completion" 
            style={{ 
                maxWidth: '360px',
                boxShadow: '0 15px 30px rgba(0, 0, 0, 0.25)',
                borderRadius: '4px',
                transform: 'perspective(1000px) rotateY(15deg) rotateX(5deg)'
            }} 
        />,
    },
];

export const steps = [

        {
            title: "Why do I need it?",
            paragraphs: [
                `
                    The terminal looks plain. Just a blinking cursor. But behind that simplicity is a tool that developers swear by — because it’s fast, efficient, and powerful.
                `,
                `
                    From navigating files to managing code and deploying servers, the terminal becomes your command center. It feels like magic when things start clicking — what used to be a chore becomes effortless. 
                `,
                `
                    And the best part? You don’t just use it — you start to love it. The terminal transforms how you work, and once you’re comfortable, you won’t look back.
                `,
            ],
        },
        {
            title: "How does it work?",
            paragraphs: [
                `
                    This platform was built from the ground up over three years, designed solely to teach you the terminal. While other platforms cover a bit of everything, this one is focused entirely on mastering the command line.`,
                `
                    Interactive exercises run directly in your browser’s terminal. The system tracks your actions and offers contextual guidance to support your learning.      
                `,
                `
                    The core curriculum teaches critical terminal skills efficiently. Additional content includes command tutorials, technical articles, and reference cheatsheets.
                `,
            ],
        },
        {
            title: "Who is the author?",
            paragraphs: [
                `
                    I’m Alen Čaljkušić, a software developer and platform engineer with over a decade of experience.
                `,
                `
                    I’ve worked with industry leaders like Activision Blizzard, as well as startups, telecoms, and major banks.
                `,
                `
                    I'm an AWS Certified Solutions Architect – Professional and hold a full Kubernetes certification. My expertise spans large-scale systems, cloud infrastructure, and container technologies. I love working on large systems and modern cloud tech like containers and microservices.
                `,
            ],
        },
];

export const testemonials = [
    {
        name: "Michael Hawks",
        role: "Software Developer",
        rating: 5,
        text: `
            What I love about learncmd.io is how quickly you can start doing, not just reading. Unlike other platforms that are text-heavy and passive, this one gives you an interactive terminal and hands-on tutorials. It’s perfect for anyone who wants to learn by doing.
        `,
        image: michael,
    },
    {
        name: "Paul Felton",
        role: "Oil industry engineer",
        rating: 5,
        text: `
            In the oil industry, working with the Linux Terminal became part of my day-to-day tasks. The learncmd.io beta was a perfect fit—informative and interactive, it made learning the terminal fast and practical.
        `,
        image: paul,
    },
    {
        name: "Kate Hooper",
        role: "Software Developer",
        rating: 5,
        text: `
            I'm a total beginner when it comes to command
            line and I was looking for a good place to start. learncmd.io
            is just what I needed! The tutorials are very well-made, and
            interactive which makes learning the basics of Linux so much
            easier, especially if you have minimal knowledge about operating
            systems. Highly recommended for all beginners!
        `,
        image: kate,
    },
];

export const plans = [
    {
        title: "Starter",
        bulletsDescription: "Try out LearnCMD for free:",
        bullets: [
            "2 Main Course lessons",
            "Limited cheat-sheets and articles",
        ],
        priceDisclaimer: "No credit card required",
    },
    {
        title: "Premium",
        bulletsDescription:
            "Full access to all available content:",
        bullets: [
            "Full Main Course - 10 modules",
            "Full cheat-sheets and articles",
            "Certificate of completion",
            "Access to the private Discord community",
        ],
        price: 59.99,
        priceDisclaimer: "7 days money back guarantee",
    },

];
